export interface IPage {
    page: number;
    pageSize: number;
}

export const initialPageModel: IPage =
    {
        page: 1,
        pageSize: 10
    };